/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, OnInit} from '@angular/core';
import {DisplayNotificationUiPanelService} from '../../services/display-notification-ui-panel.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {NotificationVoModel} from '../../models/notificationVo.model';
import {NotificationDataService} from '../../services/notification-data.service';
import {Observable} from 'rxjs';
import {NavigationService} from '@irian-ro/navigation-module';

@Component({
  selector: 'irian-ro-mpm-notification-ui-panel, mpm-notification-ui-panel',
  templateUrl: './notification-ui-panel.component.html',
  styleUrls: ['./notification-ui-panel.component.scss'],
  animations: [
    trigger('notificationState', [
      transition('void => *', [style({right: '-300px'}), animate('200ms ease', style({right: '0'}))]),
      transition('* => void', [style({right: '0'}), animate('200ms ease', style({right: '-300px'}))])
    ])
  ]

})
export class NotificationUiPanelComponent implements OnInit {

  notifications: Observable<NotificationVoModel[]> | undefined = undefined;

  top: string | undefined = undefined;
  left: string | undefined = undefined;
  public state = true;

  public notificationsVo: Array<NotificationVoModel> | undefined = undefined;

  constructor(public displayNotificationUiPanelService: DisplayNotificationUiPanelService,
              private notificationDataService: NotificationDataService,
              private navigationService: NavigationService) {
  }

  ngOnInit() {
    this.notifications = this.notificationDataService.getNotification();
  }

  reset() {
    this.state = false;
    setTimeout(() => {
      this.displayNotificationUiPanelService.reset();
    }, 200);
  }

  markAsSeen(notifications: NotificationVoModel) {
    if (notifications.status !== 'SEEN') {
      this.notificationDataService.markAsSeen(notifications);
    }
  }

  remove(event: any, notifications: NotificationVoModel) {
    event.preventDefault();
    event.stopPropagation();
    this.notificationDataService.remove(notifications);
  }

  onNotificationClick(notification: NotificationVoModel): void {
    this.markAsSeen(notification);
    if (notification.uuids && notification.uuids.length > 0) {
      this.navigationService.navigateByKeyV2(notification.actionKeyGroup, notification.params);
    } else {
      this.navigationService.navigateByKeyV2(notification.actionKey, notification.params);
    }
  }

}
